import React from "react";
import { Button, Container, Row, Col, Card, CardBody, CardTitle, CardText } from "reactstrap";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
  const navigate = useNavigate();

 
  return (
    <div className="bg-light min-vh-100 d-flex flex-column">
      {/* Hero Section */}
  <div
  className="d-flex flex-column justify-content-center align-items-center text-white text-center py-5"
  style={{
    background: "linear-gradient(135deg, #2196f3 0%, #21cbf3 100%)",
    boxShadow: "0 6px 32px rgba(33, 203, 243, 0.15)",
    minHeight: '50vh'
  }}
>
  <h1 className="display-3 fw-bold mb-3 animate__animated animate__fadeInDown">
    Web Product Configurator
  </h1>
  <p className="lead mb-4 animate__animated animate__fadeInUp">
    {/* Smartly preview, and manage your CAD files */}
  </p>
  <Button
    color="light"
    size="lg"
    className="px-5 shadow mb-3"
    onClick={()=>navigate("/productConfigurator")}
    style={{ color: "#2196f3", fontWeight: 600, borderRadius: "30px" }}
  >
    🚀 Check Demo
  </Button>
</div>


      {/* Features Section */}
    <Container className="flex-grow-1 my-5">
  <Row className="g-4 justify-content-center">
    <Col xs={12} md={6} lg={4}>
      <Card className="shadow-lg h-100 border-0 rounded-4 feature-card">
        <CardBody>
          <div className="text-center mb-2">
            {/* Search SVG */}
            <svg width="38" height="38" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <circle cx="11" cy="11" r="8" stroke="#2196f3" strokeWidth="2"/>
              <line x1="21" y1="21" x2="16.65" y2="16.65" stroke="#2196f3" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <CardTitle tag="h5" className="mb-2 fw-bold">
           Web configuration 
          </CardTitle>
          <CardText>
        Design or  Configure your product from anywhere the world
          </CardText>
        </CardBody>
      </Card>
    </Col>

    <Col xs={12} md={6} lg={4}>
      <Card className="shadow-lg h-100 border-0 rounded-4 feature-card">
        <CardBody>
          <div className="text-center mb-2">
            {/* 2D/3D SVG */}
            <svg width="38" height="38" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <rect x="3" y="7" width="18" height="10" rx="2" stroke="#43a047" strokeWidth="2"/>
              <circle cx="8.5" cy="12" r="1.5" fill="#43a047" />
              <rect x="13" y="10" width="5" height="4" rx="1" stroke="#43a047" strokeWidth="2"/>
            </svg>
          </div>
          <CardTitle tag="h5" className="mb-2 fw-bold">
            2D &amp; 3D Preview
          </CardTitle>
          <CardText>
            View PDFs in 2D and STL models in interactive 3D directly in the browser.
          </CardText>
        </CardBody>
      </Card>
    </Col>

    <Col xs={12} md={6} lg={4}>
      <Card className="shadow-lg h-100 border-0 rounded-4 feature-card">
        <CardBody>
          <div className="text-center mb-2">
            {/* Download SVG */}
            <svg width="38" height="38" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M12 4v12m0 0l-5-5m5 5l5-5" stroke="#ff9800" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <rect x="4" y="18" width="16" height="2" rx="1" fill="#ff9800" />
            </svg>
          </div>
          <CardTitle tag="h5" className="mb-2 fw-bold">
            Easy Downloads
          </CardTitle>
          <CardText>
            Download files in multiple formats including PDF, STL, and STEP securely.
          </CardText>
        </CardBody>
      </Card>
    </Col>
  </Row>
</Container>


      {/* Footer */}
      <footer className="bg-dark text-white text-center py-3 mt-auto">
        <p className="mb-0">
          © {new Date().getFullYear()} SolidWorks Matcher. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default HomePage;